/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../../../../../Routes/routes'

import Button from '../../../../../components/Button'
import Notifications from '../../../../../components/Notifications/Notifications'
import useResize from '../../../../../hooks/useResize'
import { userInfo } from '../../../../../localStorage'
import MenuBurgerTwoIcon from '../../../../../icons/MenuBurgerTwoIcon'
import { VIEWPORT_LG } from '../../../../../utils/constants'
import HutritGreenIcon from '../../../../../icons/HutritGreenIcon'
import { useTranslation } from 'react-i18next'
import SearchTalents from '../../../../../components/SearchTalents'
import MenuBurgerIcon from '../../../../../icons/MenuBurgerIcon'
import { useLandingStore, useNewLandingStore } from '../../../../../store'
import RegisterDropdown from '../../../../../components/Navbar/components/RegisterDropdown'
import Translate from '../../../../../components/Navbar/components/Translate'
import hutrit_next_navbar_icon from '../images/hutrit_next_navbar_icon.svg'

const NavbarHutritNext = ({
  setOpenDrawer = () => {},
  isQuickOffer = false,
  isSuperSearch = false,
  isLanding = false,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { offerManagementId, invitationCode } = useParams()

  const { setFormState } = useNewLandingStore()
  const { typeOfLanding, setTypeOfLanding } = useLandingStore()
  const token = JSON.parse(localStorage.getItem('token'))

  const typeOfUser = userInfo?.payload?.typeUser
  const viewPortSize = useResize()
  const isMobile = viewPortSize[0] <= VIEWPORT_LG

  const [scroll, setScroll] = useState(false)
  const [openUserOptions, setOpenUserOptions] = useState(false)

  const handleNavigation = useCallback(() => {
    setScroll(!window.scrollY <= 0)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleNavigation)
    return () => {
      window.removeEventListener('scroll', handleNavigation)
    }
  }, [handleNavigation])

  const handleLogin = () => {
    navigate(PUBLIC_ROUTES.login)
  }

  const handleGoToRegister = () => {
    navigate(
      offerManagementId && invitationCode
        ? `/register-talent-by-vacancies-link/${invitationCode}`
        : '/tm-link/IzY4MC1S/es'
    )
  }

  const renderNavbar = isLanding ? (
    <header>
      <nav
        className={`${isMobile ? '' : 'fixed-nav'} navbar`}
        style={{ paddingLeft: '32px', paddingRight: '32px', zIndex: 200 }}
      >
        <div className="d-flex container-fluid w-100 mt-2 mb-2">
          <a className="mt-2 cursor-pointer" onClick={() => setFormState(5)}>
            {viewPortSize[0] <= VIEWPORT_LG ? (
              <HutritGreenIcon fill="#004949" width="78" height="21" />
            ) : isQuickOffer ? (
              <HutritGreenIcon fill="#004949" width="78" height="21" />
            ) : (
              <HutritGreenIcon fill="#004949" width="78" height="21" />
            )}
          </a>
          {isSuperSearch && (
            <div className="d-lg-flex d-none">
              <SearchTalents isSuperSearch={isSuperSearch} />
            </div>
          )}
          {/* {!isSuperSearch && (
            <div
              className="cursor-pointer d-lg-flex d-none"
              onClick={() => navigate('/super-search/')}
              style={{marginLeft: '200px'}}
            >
              <ButtonSuperSearchIcon />
            </div>
          )} */}
          <div
            className="d-lg-none d-flex cursor-pointer"
            onClick={() => setOpenDrawer((prevState) => !prevState)}
          >
            <MenuBurgerIcon />
          </div>

          <div className="d-none d-lg-flex flex-row align-items-center">
            <div className="login d-lg-inline-block  me-4">
              <span
                onClick={handleLogin}
                className="text-on-bg-primary cursor-pointer"
              >
                {t('log_in')}
              </span>
            </div>
            {window.location.pathname !== '/' && (
              <Button
                id="navbar-register-button"
                className="border-bg-CTA-primary text-bg-CTA-primary"
                onClick={handleGoToRegister}
                style={{
                  background: 'transparent',
                }}
              >
                {t('sign_up')}
              </Button>
            )}
            {window.location.pathname === '/' && <RegisterDropdown />}
            <div className="ms-2 d-none">
              <Translate isQuickOffer={isQuickOffer} />
            </div>
          </div>
          <Notifications
            typeOfUser={typeOfUser}
            openUserOptions={openUserOptions}
            setOpenUserOptions={setOpenUserOptions}
            token={token}
            userInfo={userInfo}
          />
        </div>
      </nav>
    </header>
  ) : (
    <header
      className={`${
        window.location.pathname === PRIVATE_ROUTES.talents ? 'mb-2' : ''
      }  ${
        viewPortSize[0] <= VIEWPORT_LG
          ? 'bg-bg-brand-pressed'
          : isQuickOffer
          ? 'bg-on-bg-Tertiary-hover'
          : 'bg-bg-brand-pressed'
      } `}
    >
      <nav
        className={`navbar fixed-nav ${
          scroll
            ? 'bg-bg-brand-pressed srollNavbarStyles'
            : viewPortSize[0] <= VIEWPORT_LG
            ? ''
            : 'px-5'
        } ${isMobile ? 'bg-bg-brand-pressed srollNavbarStyles' : ''}`}
      >
        <div className="container-fluid mt-2 mb-2">
          <a
            className={`${
              scroll ? 'fixed-margin-left' : ''
            }  mt-2 cursor-pointer`}
            onClick={() => navigate(PUBLIC_ROUTES.home)}
          >
            {viewPortSize[0] <= VIEWPORT_LG ? (
              <img src={hutrit_next_navbar_icon} width={150} />
            ) : isQuickOffer ? (
              <img src={hutrit_next_navbar_icon} width={150} />
            ) : (
              <img src={hutrit_next_navbar_icon} width={150} />
            )}
          </a>

          {isSuperSearch && (
            <div className="d-lg-flex d-none">
              <SearchTalents isSuperSearch={isSuperSearch} />
            </div>
          )}
          <div
            className="d-lg-none d-flex cursor-pointer"
            onClick={() => setOpenDrawer((prevState) => !prevState)}
          >
            <MenuBurgerTwoIcon />
          </div>
          {window.location.pathname === '/' && !isMobile && (
            <div
              className="d-flex align-items-center text-white"
              style={{
                gap: isMobile ? '' : '40px',
              }}
            >
              <span
                className={`${
                  typeOfLanding === 'company' ? 'buttonSelectLandingFocus' : ''
                } buttonSelectLanding`}
                onClick={() => setTypeOfLanding('company')}
              >
                Soy empresa
              </span>
              <span
                className={`${
                  typeOfLanding === 'talent' ? 'buttonSelectLandingFocus' : ''
                } buttonSelectLanding d-none`}
                onClick={() => setTypeOfLanding('talent')}
              >
                Soy talento
              </span>
              <span
                className={`${
                  typeOfLanding === 'tm' ? 'buttonSelectLandingFocus' : ''
                } buttonSelectLanding d-none`}
                onClick={() => setTypeOfLanding('tm')}
              >
                Partners
              </span>
            </div>
          )}
          <div
            className={`${
              scroll ? 'fixed-margin-right' : ''
            } d-none d-lg-flex flex-row align-items-center `}
          >
            <div className="login d-lg-inline-block  me-4">
              <span
                onClick={handleLogin}
                className={`${
                  isQuickOffer && !scroll
                    ? 'text-on-bg-primary'
                    : scroll
                    ? 'text-white'
                    : 'text-on-bg-primary'
                } cursor-pointer`}
              >
                {t('log_in')}
              </span>
            </div>
            {window.location.pathname !== '/' && (
              <Button
                id="navbar-register-button"
                className={`${
                  isQuickOffer && !scroll
                    ? 'bg-on-bg-Tertiary-hover border-on-bg-primary'
                    : scroll
                    ? 'btn-bg-brand border-bg-CTA-primary text-bg-CTA-primary'
                    : ''
                }`}
                onClick={handleGoToRegister}
              >
                {t('sign_up')}
              </Button>
            )}
            {window.location.pathname === '/' && <RegisterDropdown />}
            <div className="ms-5 d-none">
              <Translate isQuickOffer={isQuickOffer} />
            </div>
          </div>
        </div>
      </nav>
    </header>
  )

  return renderNavbar
}

export default NavbarHutritNext
